import { createFileRoute } from '@tanstack/react-router';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Building2 } from 'lucide-react';

export const Route = createFileRoute('/_dashboard/admin/superadmin/organizations')({
  component: SuperAdminOrganizationsPage,
});

function SuperAdminOrganizationsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Organizations</h1>
        <p className="text-muted-foreground">Manage all organizations on the platform</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Building2 className="h-5 w-5" />
            All Organizations
          </CardTitle>
          <CardDescription>View and manage platform organizations</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">Organization management interface coming soon...</p>
        </CardContent>
      </Card>
    </div>
  );
}
